import CustomTable from '@/components/CustomTable/CustomTable.vue';
import AssetCard from '@/components/CustomCard/AssetCard.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import SearchBar from '@/components/SearchBar/SearchBar.vue';
import AssetInfoModal from '@/components/AssetInfoModal/AssetInfoModal.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { format_date } from '@/utils/date_formatter';
import { useToast } from "@/components/Toast/useToast";
import { validate_id, validate_namibian_id, is_valid_email, is_valid_phone_number, is_valid_registration_number, format_business_registration_number } from '@/utils/validations';
import Swal from 'sweetalert2';

export default {
  name: 'CreateAsset',
  mixins: [LOGOUT],
  setup() {
    const { showSuccess, showError, showWarning } = useToast();

    return {
      showSuccess,
      showError,
      showWarning
    };
  },
  components: {
    NavBar,
    CustomTable,
    AssetCard,
    SearchBar,
    AssetInfoModal
  },
  data() {
    return {
      data_table: null,
      asset_name: '',
      asset_description: '',
      asset_type: '',
      asset_types: [],
      active_workflows: [],
      asset_file: null,
      image_url: null,
      selected_asset: '',
      selected_workflow_id: null,
      created_asset_id: null,
      showAssetModal: false,
      selectedAssetId: null,
      is_assigned: false,
      selected_workflow: null,
      show_dropdown: false,
      highlighted_index: 0,
      selected_workflow_name: '',
      search_query: '',
      search_query_assets: '',
      loading: true,
      assets: [],
      filtered_assets: [],
      asset_categories: [],
      customer_first_name: '',
      customer_last_name: '',
      customer_email: '',
      customer_phone_number: '',
      customer_id_number: '', // ID Number for individual customers
      // New customer modal fields
      customer_step: 'select', // 'select' or 'details'
      customer_type: null, // 'company' or 'individual'
      company_name: '',
      company_registration_number: '',
      // Phone input fields for intl-tel-input
      phoneInputInstance: null,
      selectedCountryData: null,
      phone_number_error: false,
      columns: [
        { label: 'Asset Name', key: 'asset_name' },
        { label: 'Date Created', key: 'date_created' },
        { label: 'Status', key: 'asset_status' },
      ],
      user_role: '',
    };
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    toggle_dropdown() {
      this.show_dropdown = !this.show_dropdown;
      if (this.show_dropdown) {
        this.highlighted_index = 0;
      }
    },

    select_workflow(workflow) {
      this.selected_workflow_id = workflow.id;
      this.selected_workflow_name = workflow.workflow_name;
      this.search_query = '';  // Clear search after selection
      this.show_dropdown = false;
      this.highlighted_index = 0;
    },

    select_highlighted() {
      if (this.filtered_workflows.length > 0 && this.highlighted_index >= 0) {
        this.select_workflow(this.filtered_workflows[this.highlighted_index]);
      }
    },

    navigate_down() {
      if (!this.show_dropdown) {
        this.show_dropdown = true;
        return;
      }
      if (this.highlighted_index < this.filtered_workflows.length - 1) {
        this.highlighted_index++;
      }
    },

    navigate_up() {
      if (this.highlighted_index > 0) {
        this.highlighted_index--;
      }
    },

    open_assign_modal(asset) {
      this.selected_asset = asset;
      this.selected_workflow_id = '';
      this.search_query = '';
      this.selected_workflow_name = '';
      this.show_dropdown = false;
      this.highlighted_index = 0;
    },

    open_add_customer_modal(asset = null) {
      this.selected_asset = asset;
      this.reset_customer_modal();
    },

    reset_customer_modal() {
      this.customer_step = 'select';
      this.customer_type = null;
      this.customer_first_name = '';
      this.customer_last_name = '';
      this.customer_email = '';
      this.customer_phone_number = '';
      this.customer_id_number = '';
      this.company_name = '';
      this.company_registration_number = '';
      this.phone_number_error = false;
      if (this.phoneInputInstance) {
        this.phoneInputInstance.setNumber('');
      }
      $('.customer-email-error').addClass('d-none');
      $('.customer-phone-error').addClass('d-none');
      $('.customer-id-error').addClass('d-none');
    },

    // Close dropdown when clicking outside
    handle_click_outside(event) {
      if (this.$refs.searchable_select && !this.$refs.searchable_select.contains(event.target)) {
        this.show_dropdown = false;
      }
    },
    toggle_asset_status(asset) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const TOGGLE_ASSET_STATUS_URL = `${BASE_URL}/verify_api/workflow_management_api/toggle_asset_status_api/`;

      $.ajax({
        method: 'POST',
        url: TOGGLE_ASSET_STATUS_URL,
        data: JSON.stringify({ asset_id: asset.id }),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {

        },
        success: (response) => {
          const assetIndex = this.assets.findIndex(a => a.id === asset.id);
          if (assetIndex !== -1) {
            this.assets[assetIndex].is_active = !this.assets[assetIndex].is_active;

            setTimeout(() => {
              this.filtered_assets = [...this.assets];
              this.organizeAssetsIntoCategories();
            }, 500);
          }
          this.showSuccess(response.message);
        },
        error: (error) => {
          this.showError(error.responseJSON ? error.responseJSON.message : 'An error occurred.');
        },
      });
    },

    handleAssetToggle(data) {
      this.toggle_asset_status(data.asset);
    },

    handleAssetAssign(asset) {
      this.open_assign_modal(asset);
      $('#assign_asset_to_workflow_modal').modal('show');
    },

    handleAddCustomer(asset) {
      this.open_add_customer_modal(asset);
      $('#add_customer_to_asset_modal').modal('show');
    },

    async handleOnBehalfApplication(asset) {
      // Check if asset already has workflow_id (from load_all_assets enrichment)
      if (asset.workflow_id) {
        const token = localStorage.getItem('token');
        const endpoint = `${API_BASE_URL}/verify_api/workflow_management_api/get_pending_behalf_applications/${asset.workflow_id}/`;

        try {
          const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${token}`
            }
          });
          const result = await response.json();

          if (response.ok && result.status === 'success' && result.data?.pending_applications?.length > 0) {
            this.showPendingApplicationsDialog(asset.workflow_id);
          } else {
            this.StartNewApplicationDialog(asset.workflow_id);
          }
        } catch (error) {
          this.StartNewApplicationDialog(asset.workflow_id);
        }
      } else {
        this.showError('No workflow assigned to this asset');
      }
    },

    filterAssets() {
      if (!this.search_query_assets.trim()) {
        this.filtered_assets = [...this.assets];
      } else {
        const query = this.search_query_assets.toLowerCase();
        this.filtered_assets = this.assets.filter(asset =>
          asset.asset_name.toLowerCase().includes(query)
        );
      }
      this.organizeAssetsIntoCategories();
    },

    organizeAssetsIntoCategories() {
      const assignedAssets = this.filtered_assets.filter(asset => asset.is_assigned && asset.is_active);
      const inactiveUnassignedAssets = this.filtered_assets.filter(asset => !asset.is_assigned || !asset.is_active);

      this.asset_categories = [
        {
          id: 1,
          name: "Assigned",
          assets: assignedAssets
        },
        {
          id: 2,
          name: "Unassigned / Inactive",
          assets: inactiveUnassignedAssets
        }
      ].filter(category => category.assets.length > 0);
    },

    clearSearch() {
      this.search_query_assets = '';
      this.filterAssets();
    },

    async load_all_assets() {
      this.loading = true;
      const TOKEN = localStorage.getItem('token');
      const url = `${API_BASE_URL}/verify_api/workflow_management_api/get_assets/`;

      try {
        const response = await $.ajax({
          url,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          }
        });

        const assets = response.results || [];

        // Enrich assigned assets with workflow_id
        const enrichedAssets = await Promise.all(
          assets.map(async (asset) => {
            if (asset.is_assigned) {
              try {
                const workflowData = await this.fetch_asset_workflow(asset.id);
                return {
                  ...asset,
                  workflow_id: workflowData.workflow_id || null,
                  workflow_name: workflowData.workflow_name || null
                };
              } catch (error) {
                console.error(`Failed to fetch workflow for asset ${asset.id}:`, error);
                return asset;
              }
            }
            return asset;
          })
        );

        this.assets = enrichedAssets;
        this.filterAssets();
      } catch (error) {
        this.showError('Failed to load assets');
        console.error('Error loading assets:', error);
      } finally {
        this.loading = false;
      }
    },

    fetch_asset_workflow(asset_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSET_WORKFLOW_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_workflows_api/${asset_id}/`;

      return new Promise((resolve, reject) => {
        $.ajax({
          method: 'GET',
          url: GET_ASSET_WORKFLOW_URL,
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            if (response.asset_workflows && response.asset_workflows.length > 0) {
              const firstWorkflow = response.asset_workflows[0];
              resolve({
                workflow_name: firstWorkflow.workflow?.workflow_name || null,
                workflow_id: firstWorkflow.workflow?.id || null
              });
            } else {
              resolve({
                workflow_name: null,
                workflow_id: null
              });
            }
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    },
    fetch_assets(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_assets/?page=${page}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          url,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: (response) => {
            resolve({
              count: response.count,
              results: response.results
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          }
        });
      });
    },

    fetch_asset_types() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSETS_TYPES_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_types/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSETS_TYPES_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.asset_types = response.asset_types;
        },
        error: (error) => {
          this.showError(error.responseJSON ? error.responseJSON.message : 'An error occurred.');
        }
      });
    },

    get_active_worfklows() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSETS_TYPES_URL = `${BASE_URL}/verify_api/workflow_management_api/get_active_workflows_api/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSETS_TYPES_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          this.active_workflows = response.active_workflows;
        },
        error: (error) => {
          this.showError(error.responseJSON ? error.responseJSON.message : 'An error occurred.');
        }
      });
    },

    async assign_to_workflow(asset, workflow_id) {
      const workflow = this.active_workflows.find(w => w.id === workflow_id);

      // Ensure both asset and workflow are found before showing the confirmation dialog
      if (asset && workflow) {
        // Show confirmation dialog with asset name and workflow name
        const result = await Swal.fire({
          title: 'Assign Asset to Workflow',
          text: `Are you sure you want to assign the asset: ${asset.asset_name} to the workflow: ${workflow.workflow_name}? Changes cannot be reverted.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Assign it',
          cancelButtonText: 'No, Cancel',
          reverseButtons: true
        });

        if (result.isConfirmed) {
          // Proceed with assigning the asset to the workflow
          const TOKEN = localStorage.getItem('token');
          const BASE_URL = API_BASE_URL;
          const ASSIGN_ASSET_TO_WORKFLOW_URL = `${BASE_URL}/verify_api/workflow_management_api/assign_asset_to_workflow_api/`;
          const FORM_DATA = {
            asset_id: asset.id,
            workflow_id: workflow_id
          };

          $.ajax({
            method: 'POST',
            url: ASSIGN_ASSET_TO_WORKFLOW_URL,
            data: JSON.stringify(FORM_DATA),
            contentType: 'application/json',
            headers: {
              Authorization: `Token ${TOKEN}`,
            },
            beforeSend: () => {

            },
            success: (response) => {
              if (response.is_assigned) {
                this.load_all_assets();
                this.showSuccess('Asset assigned to workflow successfully');
                setTimeout(() => {
                  asset.is_assigned = true;
                  $('#assign_asset_to_workflow_modal').modal('hide');
                }, 1500);
              } else {
                this.showWarning('Asset already assigned to the selected workflow');
              }
            },
            error: (error) => {
              this.showError(error.responseJSON.message || 'An error occurred while assigning the asset');
            },
          });
        }
      } else {
        this.showError('Asset or workflow not found.');
      }
    },

    trigger_file_upload() {
      this.$refs.fileInput.click();
    },

    handle_file_upload(event) {
      const file = event.target.files[0];

      // Validate file type
      if (file && !file.type.startsWith('image/')) {
        this.showError('Please select a valid image file.');
        return;
      }

      // Validate file size (e.g., max 5MB)
      const max_size = 5 * 1024 * 1024; // 5MB
      if (file && file.size > max_size) {
        this.showError('File size exceeds 5MB limit.');
        return;
      }

      this.asset_file = file;

      // Handle image preview
      if (this.asset_file && this.asset_file.type.startsWith('image/')) {
        // Revoke existing object URL if any
        if (this.image_url && this.image_url.startsWith('blob:')) {
          URL.revokeObjectURL(this.image_url);
        }
        // Create a new object URL for the uploaded image
        this.image_url = URL.createObjectURL(this.asset_file);
      } else {
        // If not an image file, reset the image_url and asset_file
        if (this.image_url && this.image_url.startsWith('blob:')) {
          URL.revokeObjectURL(this.image_url);
        }
        this.image_url = null;
        this.asset_file = null;
      }
    },

    create_asset() {
      if (!this.asset_name || !this.asset_description || !this.asset_type) {
        this.showError('All fields are required');
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const CREATE_ASSET_URL = `${BASE_URL}/verify_api/workflow_management_api/create_asset_api/`;

      const form_data = new FormData();
      form_data.append('asset_name', this.asset_name);
      form_data.append('asset_description', this.asset_description);
      form_data.append('asset_type', this.asset_type);
      form_data.append('asset_file', this.asset_file);

      $.ajax({
        method: 'POST',
        url: CREATE_ASSET_URL,
        data: form_data,
        contentType: false,
        processData: false,
        headers: {
          Authorization: `Token ${TOKEN}`,

        },
        beforeSend: () => {

        },
        success: (response) => {
          this.showSuccess(response.message);
          setTimeout(() => {
            this.load_all_assets();
            $('#create_asset_modal').modal('hide');
            this.asset_name = '';
            this.asset_description = '';
            this.asset_type = '';
            this.asset_file = null;
            this.image_url = null;
          }, 1500);
        },
        error: (error) => {
          this.showError(error.responseJSON ? error.responseJSON.message : 'An error occurred.');
        },
      });
    },

    add_customer_to_asset() {
      if (!this.selected_asset) {
        this.showError('Please select an asset');
        return;
      }

      // Validate based on customer type
      if (this.customer_type === 'company') {
        if (!this.company_registration_number || !this.company_name || !this.customer_email || !this.customer_phone_number) {
          this.showError('All fields are required');
          return;
        }

        // Validate registration number format using utility
        if (!is_valid_registration_number(this.company_registration_number)) {
          this.showError('Invalid registration number format. Use format: YYYY/NNNNNN/NN');
          return;
        }
      } else {
        if (!this.customer_first_name || !this.customer_last_name || !this.customer_id_number || !this.customer_email || !this.customer_phone_number) {
          this.showError('All fields are required');
          return;
        }

        // Validate ID number
        if (!validate_id(this.customer_id_number) && !validate_namibian_id(this.customer_id_number)) {
          this.showError('Invalid ID number');
          return;
        }
      }

      // Validate email using utility
      if (!is_valid_email(this.customer_email)) {
        $('.customer-email-error').text('Please enter a valid email address').removeClass('d-none');
        return;
      }

      // Validate phone number using utility
      if (!is_valid_phone_number(this.customer_phone_number)) {
        $('.customer-phone-error').text('Invalid phone number').removeClass('d-none');
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const ADD_CUSTOMER_URL = `${BASE_URL}/verify_api/system_management_api/add_customer_to_asset_api/`;

      const form_data = {
        asset_id: this.selected_asset.id,
        customer_type: this.customer_type,
        first_name: this.customer_first_name,
        last_name: this.customer_last_name || '',
        email: this.customer_email,
        phone_number: this.customer_phone_number,
        // Individual-specific field
        id_number: this.customer_id_number || null,
        // Company-specific fields
        company_name: this.company_name || null,
        registration_number: this.company_registration_number || null
      };

      $.ajax({
        method: 'POST',
        url: ADD_CUSTOMER_URL,
        data: JSON.stringify(form_data),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          $('.customer-email-error').addClass('d-none');
          $('.customer-phone-error').addClass('d-none');
          $('.customer-id-error').addClass('d-none');
        },
        success: (response) => {
          // Handle success and partial_success statuses
          if (response.status === 'success' || response.status === 'partial_success') {
            $('#add_customer_to_asset_modal').modal('hide');
            this.showSuccess(response.message || 'Customer created successfully and invitation email sent');

            // Reset form fields
            this.selected_asset = '';
            this.customer_first_name = '';
            this.customer_last_name = '';
            this.customer_email = '';
            this.customer_phone_number = '';
            this.customer_id_number = '';
            this.company_registration_number = '';
            this.company_name = '';
          }
        },
        error: (xhr) => {
          const response = xhr.responseJSON || {};
          const errorCode = response.error_code;
          const message = response.message || 'An error occurred while adding customer';
          const errors = response.errors || {};

          // Handle validation errors with field-specific messages
          if (errorCode === 'VALIDATION_ERROR' && Object.keys(errors).length > 0) {
            // Check for specific field errors
            if (errors.email) {
              const emailError = Array.isArray(errors.email) ? errors.email[0] : errors.email;
              $('.customer-email-error').text(emailError).removeClass('d-none');
            }
            if (errors.phone_number) {
              const phoneError = Array.isArray(errors.phone_number) ? errors.phone_number[0] : errors.phone_number;
              $('.customer-phone-error').text(phoneError).removeClass('d-none');
            }
            if (errors.id_number) {
              const idError = Array.isArray(errors.id_number) ? errors.id_number[0] : errors.id_number;
              $('.customer-id-error').text(idError).removeClass('d-none');
            }
            if (errors.registration_number) {
              this.showError(Array.isArray(errors.registration_number) ? errors.registration_number[0] : errors.registration_number);
            }
            
            // Show general message if no specific field errors displayed
            const hasFieldErrors = errors.email || errors.phone_number || errors.id_number || errors.registration_number;
            if (!hasFieldErrors) {
              this.showError(message);
            }
          } else if (errorCode === 'ASSET_CREATION_FAILED') {
            this.showError(message);
          } else if (errorCode === 'INTERNAL_ERROR') {
            this.showError('An unexpected error occurred. Please try again later.');
          } else {
            // Fallback for legacy error format
            const errorMsg = response.error || message;
            if (typeof errorMsg === 'string') {
              if (errorMsg.toLowerCase().includes('email')) {
                $('.customer-email-error').text(errorMsg).removeClass('d-none');
              } else if (errorMsg.toLowerCase().includes('phone')) {
                $('.customer-phone-error').text(errorMsg).removeClass('d-none');
              } else if (errorMsg.toLowerCase().includes('id')) {
                $('.customer-id-error').text(errorMsg).removeClass('d-none');
              } else {
                this.showError(errorMsg);
              }
            } else {
              this.showError(message);
            }
          }
        },
      });
    },

    // Phone validation methods
    initializeCustomerPhoneInput() {
      const phoneInput = this.$refs.customerPhoneInput;
      if (!phoneInput || this.phoneInputInstance) return;

      const options = {
        initialCountry: 'za',
        preferredCountries: ['za', 'us', 'gb', 'ca'],
        allowDropdown: true,
        formatOnDisplay: true,
        formatAsYouType: true,
        nationalMode: true,
        autoPlaceholder: 'aggressive',
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.2.19/js/utils.js'
      };

      try {
        this.phoneInputInstance = window.intlTelInput(phoneInput, options);
        this.selectedCountryData = this.phoneInputInstance.getSelectedCountryData();

        phoneInput.addEventListener('input', this.handleCustomerPhoneInput);
        phoneInput.addEventListener('countrychange', this.handleCustomerCountryChange);
        phoneInput.addEventListener('blur', this.handleCustomerPhoneBlur);
      } catch (error) {
        console.error('Failed to initialize intl-tel-input:', error);
      }
    },

    destroyCustomerPhoneInput() {
      if (this.phoneInputInstance) {
        const phoneInput = this.$refs.customerPhoneInput;
        if (phoneInput) {
          phoneInput.removeEventListener('input', this.handleCustomerPhoneInput);
          phoneInput.removeEventListener('countrychange', this.handleCustomerCountryChange);
          phoneInput.removeEventListener('blur', this.handleCustomerPhoneBlur);
        }
        this.phoneInputInstance.destroy();
        this.phoneInputInstance = null;
      }
    },

    handleCustomerPhoneInput(event) {
      if (!this.phoneInputInstance) return;

      let inputValue = event.target.value;
      
      // For South Africa, convert +27 to 0
      if (this.selectedCountryData && this.selectedCountryData.iso2 === 'za') {
        if (inputValue.startsWith('+27')) {
          inputValue = '0' + inputValue.substring(3);
          event.target.value = inputValue;
        } else if (inputValue.startsWith('27') && inputValue.length > 2) {
          inputValue = '0' + inputValue.substring(2);
          event.target.value = inputValue;
        }
      }

      // Remove non-numeric characters except +
      let cleanedValue = inputValue.replace(/[^\d+]/g, '');
      
      // Limit length
      const maxLength = this.selectedCountryData && this.selectedCountryData.iso2 === 'za' ? 10 : 15;
      if (cleanedValue.length > maxLength) {
        cleanedValue = cleanedValue.substring(0, maxLength);
      }

      this.customer_phone_number = cleanedValue;
      event.target.value = cleanedValue;
      
      // Clear error on input
      this.phone_number_error = false;
      this.phone_error_message = '';
      $('.customer-phone-error').addClass('d-none');
    },

    handleCustomerCountryChange() {
      if (!this.phoneInputInstance) return;
      this.selectedCountryData = this.phoneInputInstance.getSelectedCountryData();
    },

    handleCustomerPhoneBlur() {
      if (this.customer_phone_number && !is_valid_phone_number(this.customer_phone_number)) {
        this.phone_number_error = true;
        $('.customer-phone-error').text('Invalid phone number').removeClass('d-none');
      }
    },

    formatRegistrationNumber(event) {
      const result = format_business_registration_number(event);
      if (result) {
        this.company_registration_number = result.formatted_input;
        this.$nextTick(() => {
          event.target.value = result.formatted_input;
          event.target.setSelectionRange(result.new_cursor_position, result.new_cursor_position);
        });
      }
    },

    showPendingApplicationsDialog(workflow_id) {
      Swal.fire({
        title: 'Pending Application',
        text: 'You have a pending application. Would you like to complete it or start a new application?',
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        showCloseButton: this.isToolboxClient,
        confirmButtonText: 'Complete Application',
        denyButtonText: 'New Application',
        cancelButtonText: this.cancelButtonConfig.label,
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#28a745',
        cancelButtonColor: '#6c757d'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$router.push({
            name: 'behalf_application',
            params: { workflowId: workflow_id }
          });
        } else if (result.isDenied) {
          const token = localStorage.getItem('token');
          const endpoint = `${API_BASE_URL}/verify_api/workflow_management_api/mark_workflow_complete/`;

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
              },
              body: JSON.stringify({
                workflow_id: workflow_id,
                on_behalf_application: true
              })
            });
            const result = await response.json();

            if (response.ok && result.status === 'success') {
              this.StartNewApplicationDialog(workflow_id);
            } else {
              this.showError(result.message || 'Failed to start new application');
            }
          } catch (error) {
            this.showError('An error occurred while completing the workflow');
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.$router.push({ name: this.cancelButtonConfig.route });
        }
      });
    },

    StartNewApplicationDialog(workflow_id) {
      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/create_behalf_application_api/`;

      this.loading = true;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: workflow_id
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.loading = false;
          if (response.status === 'success') {
            this.$router.push({
              name: 'behalf_application',
              params: { workflowId: workflow_id }
            });
          } else {
            this.showError(response.message || 'Failed to create behalf application');
          }
        },
        error: (error) => {
          this.loading = false;
          const errorMessage = error.responseJSON?.message || 'An error occurred while creating the behalf application';
          this.showError(errorMessage);
        }
      });
    },

    handle_blur(event) {
      if (!this.$refs.searchable_select.contains(event.relatedTarget)) {
        this.show_dropdown = false;
      }
    },

    view_asset(asset_id) {
      if (this.user_role === 'ClientAdmin') {
        this.$router.push({ name: 'view_asset', params: { id: asset_id } });
      } else {
        this.selectedAssetId = asset_id;
        this.showAssetModal = true;
      }
    },
    closeAssetModal() {
      this.showAssetModal = false;
      this.selectedAssetId = null;
    }
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.user_role = this.$store.getters.get_user_role;
    this.load_all_assets();
    this.fetch_asset_types();
    this.get_active_worfklows();

    document.removeEventListener('click', this.handle_click_outside);
  },

  beforeUnmount() {
    this.destroyCustomerPhoneInput();
  },

  watch: {
    customer_step(newVal) {
      if (newVal === 'details') {
        // Wait for the DOM to update, then initialize phone input
        this.$nextTick(() => {
          setTimeout(() => {
            this.initializeCustomerPhoneInput();
          }, 100);
        });
      } else {
        this.destroyCustomerPhoneInput();
      }
    }
  },

  computed: {
    sorted_active_workflows() {
      return [...this.active_workflows].sort((a, b) =>
        a.workflow_name.localeCompare(b.workflow_name)
      );
    },

    filtered_workflows() {
      if (!this.search_query) {
        return this.sorted_active_workflows;
      }
      return this.sorted_active_workflows.filter(workflow =>
        workflow.workflow_name.toLowerCase().includes(this.search_query.toLowerCase())
      );
    },

    assigned_assets() {
      return this.assets.filter(asset => asset.is_assigned && asset.is_active);
    },

    isToolboxClient() {
      const domain = window.location.hostname;
      const role = this.$store.getters.get_user_role;
      const targetDomains = ['swift', 'mobi', 'suzuki', 'mobiafrica'];
      return role === 'Client' && targetDomains.some(d => domain.includes(d));
    },

    cancelButtonConfig() {
      if (this.isToolboxClient) {
        return {
          label: "View Applications",
          route: 'workbench'
        };
      }
      return {
        label: "Back to Assets",
        route: 'create_asset'
      };
    }

  },

  before_destroy() {
    // Revoke the object URL when component is destroyed
    if (this.image_url && this.image_url.startsWith('blob:')) {
      URL.revokeObjectURL(this.image_url);
    }
  },
};
